import store from '@/store'

function isFacilityOwner (to) {
    return to.params?.facilityId &&  store.state.auth.national_facility_ids.includes(to.params.facilityId)
}

const configurationViewPermissions = [ "cars-view-lidar-configurations", "cars-manage-lidar-configurations" ]
const evaluationViewPermissions = [ "cars-view-lidar-evaluations", "cars-manage-lidar-evaluations" ]
const validateEvaluationPermissions = [ "ares-validate-lidar-evaluation" ]
const qaSetupViewPermissions = [ "cars-view-qa-setup" ]

const ownerOrPermissionsGate = (to, acceptedPermissions) => (acceptedPermissions.some(p => store.state.auth.permissions.includes(p)) || isFacilityOwner (to))

const configurationQaRoutes = [
    { path: '', name: 'QaConfigurationView', component: () => import('@/views/facility/cars/quality_assurance/lidar_configuration/ConfigurationView.vue'), props: true, meta: { hide: true, auth: true, gate: (to) => ownerOrPermissionsGate(to, configurationViewPermissions) } },
]

const evaluationQaRoutes = [
    { path: '', name: 'QaEvaluationView', component: () => import('@/views/facility/cars/quality_assurance/evaluation/EvaluationView.vue'), props: true, meta: { hide: true, auth: true, gate: (to) => ownerOrPermissionsGate(to, evaluationViewPermissions) } },
    { path: 'validate', name: 'QaEvaluationValidate', component: () => import('@/views/facility/cars/quality_assurance/evaluation/EvaluationValidate.vue'), meta: { label: 'Validate', auth: true, private: true, gate: (to) => ownerOrPermissionsGate(to, validateEvaluationPermissions) } }
]

const lidarQaRoutes = [
    { path: '', name: 'QaLidarSystem', component: () => import('@/views/facility/cars/quality_assurance/lidar/LidarQualityAssurance.vue'), props: true, meta: { auth: true, hide: true, gate: (to) => ownerOrPermissionsGate(to, configurationViewPermissions.concat(evaluationViewPermissions)) } },
    { path: 'setup', name: 'QaLidarSccIds', component: () => import('@/views/facility/cars/quality_assurance/lidar/SccIds.vue'), props: true, meta: { label: 'Initial Setup', auth: true, gate: (to) => ownerOrPermissionsGate(to, qaSetupViewPermissions) } },
    { path: 'configuration/:configurationId', name: 'QaConfigurationComponent', redirect: {name: 'QaConfigurationView'}, component: () => import('@/views/facility/cars/quality_assurance/lidar_configuration/ConfigurationComponent.vue'), meta: { hide: false, label: 'Configuration' }, children: configurationQaRoutes },
    { path: 'evaluation/:evaluationId', name: 'QaEvaluationComponent', redirect: {name: 'QaEvaluationView'}, component: () => import('@/views/facility/cars/quality_assurance/evaluation/EvaluationComponent.vue'), meta: { hide: false, label: 'Evaluation' }, children: evaluationQaRoutes }
]
const route = [
    {
        path: '',
        name: 'QaHome',
        component: () => import('@/views/facility/cars/quality_assurance/LidarList.vue'),
        props: true,
        meta: {
            label: 'Lidar Systems',
            hide: true,
            auth: true
        }
    },
    { path: 'lidar/:lidarId', name: 'QaLidarComponent', redirect: {name: 'QaLidarSystem'}, component: () => import('@/views/facility/cars/quality_assurance/lidar/LidarComponent.vue'), props: true, meta: { hide: false, label: 'Lidar system' }, children: lidarQaRoutes },
]
export default route